import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { Toaster } from 'react-hot-toast';
import { auth } from './config/firebase';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: 'var(--surface-color)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-color)',
            borderRadius: 'var(--border-radius-lg)',
            boxShadow: 'var(--shadow-3)',
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: 'var(--primary-color)',
              secondary: 'var(--surface-color)',
            },
            style: {
              background: 'var(--surface-color)',
              color: 'var(--text-primary)',
              border: '1px solid var(--primary-color)',
              borderRadius: 'var(--border-radius-lg)',
              boxShadow: 'var(--shadow-3)',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: 'var(--surface-color)',
            },
            style: {
              background: 'var(--surface-color)',
              color: 'var(--text-primary)',
              border: '1px solid #ef4444',
              borderRadius: 'var(--border-radius-lg)',
              boxShadow: 'var(--shadow-3)',
            },
          },
          info: {
            duration: 3000,
            iconTheme: {
              primary: 'var(--primary-color)',
              secondary: 'var(--surface-color)',
            },
            style: {
              background: 'var(--surface-color)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              borderRadius: 'var(--border-radius-lg)',
              boxShadow: 'var(--shadow-3)',
            },
          },
        }}
      />
      {user ? <Dashboard user={user} /> : <Login />}
    </div>
  );
}

export default App;
